export const prevScreenInfo = (state = {currentPath: '', prevPath: ''}, action) => {
    switch (action.type) {
        case "PREV_SCREEN_INFO": {
            return action.payload.prevScreenInfo;
        }
        default: {
            return state;
        }
    }
};